export const FULTON_LIBRARY_SCHOOL_ID = 285;
